import React, { useState } from 'react';
import './ProductCard.css';

const ProductCard = ({ interactive = true, onAddToOrder }) => {
  const [selectedPurity] = useState('22K / 916');
  const [added, setAdded] = useState(false);

  const handleAdd = () => {
    setAdded(true);
    if (onAddToOrder) onAddToOrder();
    setTimeout(() => setAdded(false), 2400);
  };

  return (
    <div className="product-intelligence-card">
      <div className="product-card-badge-row">
        <span className="spec-intel-badge">PRODUCT INTELLIGENCE SPEC</span>
        <span className="badge-verified">✓ BIS Hallmarked</span>
      </div>

      <div className="product-preview-header">
        <div className="product-img-box">
          <img 
            src="https://images.openai.com/static-rsc-4/KdoU_MhHYSmJwzIFtLDIhOS24f9eLf9TDiqpLULeS3YP55ACf3HkEb5ZCgJiS2PouLWHOooIukLthzqeSH5GNoUIRZANRBO5drVAMUPRhzp4wA5Liuy5qnP72zEOFI4050CwN0NeQFtavPfoH4Du7NXoIRQSJVVHOrZ0KKVfbx6_GENeUgPndkVZYSU8XnrG?purpose=fullsize" 
            alt="Gold Necklace Specimen" 
            className="intel-product-img"
          />
          <span className="huid-pill">HUID: 8J9K2L</span>
        </div>

        <div className="product-header-info">
          <span className="product-category-tag">BRIDAL & TRADITIONAL</span>
          <h3 className="product-name">22K Handcrafted Filigree Gold Necklace</h3>
          <div className="seller-attribution">
            <span className="seller-label">Seller:</span>
            <span className="seller-name">Surat Jewels Ltd.</span>
            <span className="seller-badge">Verified Manufacturer</span>
          </div>
        </div>
      </div>

      {/* Technical B2B Specification Grid */}
      <div className="spec-table-container">
        <div className="spec-row">
          <span className="spec-key">Gross Weight</span>
          <span className="spec-val highlight-mono">25.840 g</span>
        </div>
        <div className="spec-row">
          <span className="spec-key">Net Weight (Pure Gold)</span>
          <span className="spec-val highlight-gold">24.910 g</span>
        </div>
        <div className="spec-row">
          <span className="spec-key">Stone / Enamel Deduction</span>
          <span className="spec-val">0.930 g</span>
        </div>
        <div className="spec-row">
          <span className="spec-key">Purity Benchmark</span>
          <span className="spec-val badge-purity">{selectedPurity}</span>
        </div>
        <div className="spec-row">
          <span className="spec-key">Making Charge</span>
          <span className="spec-val">₹385 / gram</span>
        </div>
        <div className="spec-row">
          <span className="spec-key">Stamp / Certification</span>
          <span className="spec-val badge-stamp">BIS 916 + HUID Laser</span>
        </div>
        <div className="spec-row">
          <span className="spec-key">Wholesale Lot Availability</span>
          <span className="spec-val">Ready Stock (14 pieces)</span>
        </div>
      </div>

      {/* Pricing Calculation Preview */}
      <div className="commercial-breakdown-box">
        <div className="breakdown-line">
          <span>Bullion Value (@ ₹6,861/g net):</span>
          <span className="mono-num">₹1,70,907</span>
        </div>
        <div className="breakdown-line">
          <span>Making Charges (@ ₹385/g gross):</span>
          <span className="mono-num">₹9,948</span>
        </div>
        <div className="breakdown-total">
          <span className="total-label">Est. B2B Wholesale Excl. GST:</span>
          <span className="total-price">₹1,80,855</span>
        </div>
      </div>

      {/* CTA Button */}
      <button 
        className={`btn ${added ? 'btn-secondary' : 'btn-primary'} w-full add-order-btn`}
        onClick={handleAdd}
      >
        {added ? '✓ Added to B2B Purchase Order' : '+ Add to Order'}
      </button>

      <div className="card-disclaimer-sub">
        Final billing locks exact live bullion spot at the moment of order confirmation.
      </div>
    </div>
  );
};

export default ProductCard;
